export const LOYALTY_THEME = {
  BRONZE: 'Bronze',
  SILVER: 'Silver',
  GOLD: 'Gold',
};

export default {
  LOYALTY_THEME,
};
